import { render, staticRenderFns } from "./RFPBoqDetailsReview.vue?vue&type=template&id=925e724a"
import script from "./RFPBoqDetailsReview.vue?vue&type=script&lang=js"
export * from "./RFPBoqDetailsReview.vue?vue&type=script&lang=js"
import style0 from "./RFPBoqDetailsReview.vue?vue&type=style&index=0&id=925e724a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports